export const cateType = {
    product:1,
    news:2,
    trans:3,
    expert:4
}
export const contentType = {
    product:1,
    news:2,
    trans:3,
    expert:4
}
